import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { NewAgentApiService } from './new-agent-api.service';
import { Global } from '../global/globalApi';
import * as Constants from '../models/Constants';
import { AuthMethodService } from './auth-method.service';
import { HttpClient } from '@angular/common/http';
import { CallCustomerAttributes } from '../models/customer.model';
import { GenesysCloudService } from './genesys-cloud.service';
import { clearFraudIdentityData, clearIdentityData } from '../models/tab.model';
import { CustBusService } from './customer-search-bussiness-logic.service';
import { interval, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClearIdentityService {
  public fileName = "ClearIdentityService";
  public intervalId: any = null;
  public clearMsg: string = '';
  public startTime: number = 0;
  private timerSubscription?: Subscription;
  public isSubmitBtnClicked: boolean = false;
  public clickButton: boolean = false;
  constructor(public rootScope: RootScopeService, public agentService: NewAgentApiService, public customerService: CustBusService,
    public authService: AuthMethodService, public http: HttpClient, public genesysCloudService: GenesysCloudService) {

  }

cancelAidvProcessDialog() {
     
     return this.rootScope.openDialog({
        title: 'Confirm Cancellation',
        subheading: '',
        message: Constants.CLEAR_VERIFICATION_CONSTANTS.Cancel_AIDV_Process_Msg,
        firstbutton: 'No',
        secondbutton: "Yes",
        crossIcon: false,
        comingFrom: Constants.CLEAR_VERIFICATION_CONSTANTS.CANCEL_AIDV_BUTTON,
        additionalClass: 'authentication',
      });
 
   
  }

  clearInfoMessage() {
    const activeTab = this.rootScope.activeCustTab;
    let status = true;

    if (!activeTab.clearIdentityData.isClearIdentityEnabled) {
      this.clearMsg = Constants.CLEAR_IDENTITY.invalidClient;
      status = false;
    }
    else if (!this.rootScope.isLiveCall) {
      this.clearMsg = Constants.PEA_MESSAGES.AVAILABLE_DURING_LIVE_INTERACTION;
      status = false;
    }
    else if (activeTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
      this.clearMsg = '';
      status = true;
    }
    else if (!this.authService.CustTypeConfigCheck(Constants.AuthMenu.AIDV)) {
      this.clearMsg = Constants.AuthMethods.AIDV + " " + Constants.NOT_CONFIGURED_CUSTTYPE;
      status = false;
    }
    else this.clearMsg = '';

    return status;
  }

  clearCheckEligibility(event: any) {
    const payload = (event as CustomEvent<{
      uuid: string;
      checked: boolean;
      value: string;
    }>).detail;

    const activeTab = this.rootScope.activeCustTab;
    activeTab.clearIdentityData.step1CheckList = activeTab.clearIdentityData.step1CheckList.map((item) =>
      item.uuid == payload.uuid ? { ...item, checked: payload.checked } : item
    );


    activeTab.clearIdentityData.startADIV = activeTab.clearIdentityData.step1CheckList.every((item: any) => item.checked);
  }


  public clearStepsClass(step: string): string {
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    // const clearIdentityData = this.rootScope.activeCustTab.clearIdentityData;

    switch (step) {
      case '1':
        if (targetData.step1Active) {
          return !targetData.step1Complete ? 'active' : 'complete';
        }
        break;
      case '2':
        if (targetData.step2Failed) {
          return 'failure';
        }
        else if (targetData.step2Active) {
          return !targetData.step2Complete ? 'active' : 'complete';
        }
        break;
      case '3':
        if (targetData.step3Failed) {
          return 'failure';
        }
        else if (targetData.step3Active) {
          return !targetData.step3Complete ? 'active' : 'complete';
        }
        break;
    }
    return '';
  }



  private buildVerificationParams(consumerSessionId: string, verificationData: any) {
    const email = verificationData?.email || verificationData?.customEmail;
    const phone = verificationData?.mobileNumber || verificationData?.customMobileNumber;
    const countryCode = verificationData?.countryCode;

    return {
      consumerSessionId,
      email,
      phone,
      countryCode,
      mode: email ? Constants.OTC_MODES.EMAIL : Constants.OTC_MODES.TEXT
    };
  }

  private setVerificationStepState(targetData: any, isSuccess: boolean) {
    targetData.step2Complete = isSuccess;
    targetData.step3Active = isSuccess;
    targetData.step2Failed = !isSuccess;
    if (isSuccess) {
      targetData.step2ErrorMsg = "";
    }
  }

  public extractVerificationId(data: any): string {
    const payload = data?.data;
    if (!payload) {
      return '';
    }

    if (typeof payload === 'string') {
      try {
        return JSON.parse(payload)?.idvToken || '';
      } catch {
        return '';
      }
    }

    return payload?.idvToken || '';
  }

  public sendClearIdentityVerification() {
    this.isSubmitBtnClicked = true;
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess =
      activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;

    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const logLabel = isAccountAccess ? 'SendClearIdentityVerification' : 'SendClearFraudIdentityVerification';

    const params = this.buildVerificationParams(activeTab.customerSessionId, targetData);
    
    if (activeTab.clearIdentityData.identityVerificationType == Constants.CLEAR_OPTIONS_CODES.ENHANCED_IDENTITY) {
      this.rootScope.activeCustTab.isEIVSelected = true;
    }
    else {
      this.rootScope.activeCustTab.isEIVSelected = false;
    }
    // simulation mode check and if active, call the simulation method for real time experience, else proceed with the actual API call to start identity verification.
    if (this.rootScope.simulationData?.isSimulationModeActive) {
      this.simulationAIDV(targetData, isAccountAccess);
    }
    else this.agentService
      .postApi(Global.CLEAR_APIS.STARTIDENTITYVERIFICATION, params, 'false', Constants.apiVersions, false)
      .subscribe({
        next: (data: any) => {
          if (data?.httpStatusCode === 200) {
            this.setVerificationStepState(targetData, true);
            targetData.verificationId = this.extractVerificationId(data);
            this.rootScope.triggerLog(`${logLabel}: ${JSON.stringify(data?.data)}`, this.fileName, Constants.DEBUG);

            if (targetData.verificationId) {
              this.monitorVerificationStatus();
              this.startTime = Date.now();
              this.startTimer(targetData);
            }
          }
          else {
            targetData.step2ErrorMsg = this.returnErrorMsg(data?.message);
            this.setVerificationStepState(targetData, false);
          }
          this.isSubmitBtnClicked = false;

        },
        error: (error) => {
          targetData.step2ErrorMsg = this.returnErrorMsg(error?.error?.message);
          this.isSubmitBtnClicked = false;
          this.setVerificationStepState(targetData, false);
          this.rootScope.triggerLog(`${logLabel}: ${JSON.stringify(error)}`, this.fileName);
        }
      });
  }


  public getVerificationStatus(clicked?: boolean) {
    if (!this.rootScope.isLiveCall) {
      this.clearDeliveryOptionsData(true);
      return;
    }
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const url = `${Global.domainUrl}${clicked ? Global.CLEAR_APIS.REFRESH_IDV_STATUS : Global.CLEAR_APIS.POLL_CALLBACK_RESPONSE}`;

    //CCR3-14867 for simulation mode, if the simulation is active and the user has clicked on the refresh button, we will not make any API call and just return the pending message to the user.
    if (this.rootScope.simulationData?.isSimulationModeActive && clicked) {
      this.clickButton = false;
      targetData.step3InfoMsg = Constants.CLEAR_VERIFICATION_CONSTANTS.PENDING;
      return;
    }

    this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, activeTab?.customerSessionId),
      params: { verificationId: targetData?.verificationId }
    }).subscribe({
      next: (data: any) => {
        let result: any;
        try {
          result = typeof data?.data === 'string' ? JSON.parse(data.data) : data?.data;
        } catch (e) {
          this.rootScope.triggerLog(`PollCallbackResponse Parse Error: ${JSON.stringify(e)}`, this.fileName);
          this.clickButton = false;
          return;
        }
        if (result?.dataMatched === true) {
          targetData.step3Complete = true;
          targetData.step3InfoMsg = '';
          clearInterval(this.intervalId);
          this.stopTimer();
          this.updateSecurityForPpt();
          this.rootScope.triggerLog(`PollCallbackResponse: ${JSON.stringify(result)}`, this.fileName, Constants.DEBUG);
          this.resetClearIdentityData(isAccountAccess);
        }
       else if (result?.dataMatched === false) {
          targetData.step3Complete = false;
          targetData.step3Failed = true;
          targetData.step3InfoMsg = '';    
          targetData.step3ErrorMsg = this.rootScope.appConfigObj?.filter(
            x => (result.errors ?? [])?.find(v => x?.fieldName === v?.errorCode) && x.groupName === "IDV_ERROR_CODES"
          ) ?? [];
          if(targetData.step3ErrorMsg.length === 0){
            targetData.step3ErrorMsg = result.errors ?? [];
          }
          clearInterval(this.intervalId);
          this.rootScope.triggerLog(`PollCallbackResponse: ${JSON.stringify(result)}`, this.fileName);
          this.stopTimer();        
        }
        else if (clicked) {
          targetData.step3InfoMsg = Constants.CLEAR_VERIFICATION_CONSTANTS.PENDING;
          this.rootScope.triggerLog(`PollCallbackResponse: ${JSON.stringify(result)}`, this.fileName, Constants.DEBUG);
        }

        if(this.clickButton){
          this.clickButton = false;
        }
      },
      error: (error) => {
        this.rootScope.triggerLog(`PollCallbackResponse Error: ${JSON.stringify(error)}`, this.fileName);
        this.clickButton = false;
      }
    });
  }

  public monitorVerificationStatus() {
    const pollEveryMs = this.rootScope.CCTConfigs.IDV_POLL_DURATION * 1000; // convert to milliseconds
    const maxDurationMs = this.rootScope.CCTConfigs.MAX_IDV_POLL_DURATION * 1000; // convert to milliseconds
    const startedAt = Date.now();

    this.getVerificationStatus();

    this.intervalId = setInterval(() => {
      if (Date.now() - startedAt >= maxDurationMs) {
        clearInterval(this.intervalId);
        this.stopTimer(maxDurationMs);
        return;
      }
      this.getVerificationStatus();
    }, pollEveryMs);
  }



  public updateSecurityForPpt(): void {
    const accountDt = this.rootScope.activeCustTab;

    const authCode = Constants.AuthCode.AIDV;

    const model = {
      CS_SECURITY_LEVEL: Constants.securityLevels.SL4,
      authenticateStatus: Constants.FULLY_SECURED,
      iconClass: 'green',
      domain: true
    };

    const body: CallCustomerAttributes = {
      attributes: {
        PINV: 'S',
        CS_AUTH_CD: authCode,
        CS_SECURITY_LEVEL: Constants.securityLevels.SL4,
      }
    };

    accountDt.iconClass = 'green';
    accountDt.genesysAttributes = {
      ...accountDt.genesysAttributes,
      CS_AUTH_CD: authCode
    };

    const participantId =
      accountDt.customerParticipantId && accountDt.customerParticipantId !== 'NA'
        ? accountDt.customerParticipantId
        : this.rootScope.getParticipantId();

    this.genesysCloudService.updateSecurityLevelInGEN(
      accountDt.conversationId,
      participantId,
      body,
      model
    );
  }

  public getDeliveryOptions() {
    let url = Global.domainUrl + Global.authenticationApis.loadOTCConfig;
    this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        authType: "IDENTITY_VERIFICATION"
      }
    }).subscribe({
      next: (res: any) => {
        const data = res?.data;

        if (data) {
          this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumbers = data.deliveryMethods
            .filter(method => method.type === "text")
            .flatMap(method => method.details)
            .filter(Boolean);
          this.rootScope.activeCustTab.clearFraudIdentityData.emails = data.deliveryMethods
            .filter(method => method.type === "email")
            .flatMap(method => method.details)
            .filter(Boolean);
        } else {
          //this.rootScope.activeCustTab.otcData.deliveryMethodConfigMiss = true;
        }
        const mobiles = this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumbers;
        if (mobiles?.length > 0) {
          this.rootScope.activeCustTab.clearFraudIdentityData.defaultSelectedValue = mobiles[0];
          this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = mobiles[0].phoneNumber;
          this.rootScope.activeCustTab.clearFraudIdentityData.countryCode = mobiles[0].countryCode;
          this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = false;
          this.rootScope.activeCustTab.clearFraudIdentityData.isMobileSelected = true;
        }
      },
      error: (err) => {
        // this.rootScope.activeCustTab.otcData.deliveryMethodApiFail = true;  
        //this.logger.errorLogs(JSON.stringify(err), this.fileName);
      }
    })
  }

  public invalidateIdentityVerificationSession(verificationId: string) {

     //CCR3-14867 for simulation mode, if the simulation is active, we will not make any API call to invalidate the session and just stop the timer and clear the interval.
    if(this.rootScope.simulationData?.isSimulationModeActive){
      clearTimeout(this.intervalId);
      this.stopTimer();
      return;
    }

    clearInterval(this.intervalId);
    this.stopTimer();

    if (!verificationId) {
      return;
    }

    const activeTab = this.rootScope.activeCustTab;
    const url = `${Global.domainUrl}${Global.CLEAR_APIS.INVALIDATE_IDENTITY_VERIFICATION_SESSION}`;


    this.http.delete(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, activeTab?.customerSessionId),
      params: { verificationId: verificationId }
    }).subscribe({
      next: (response: any) => {
        this.rootScope.triggerLog(`InvalidateIdentityVerificationSession: ${JSON.stringify(response)}`, this.fileName, Constants.DEBUG);
      },
      error: (error: any) => {
        this.rootScope.triggerLog(`InvalidateIdentityVerificationSession Error: ${JSON.stringify(error)}`, this.fileName);
      }
    });
  }

  clearDeliveryOptionsData(clearverfication?: boolean) {
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const verificationData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const fraudVerificationData = activeTab.clearFraudIdentityData;

    verificationData.step2Complete = false;
    verificationData.step3Active = false;
    verificationData.mobileNumber = '';
    verificationData.email = '';
    //copilot code suggestions :
    verificationData.step3InfoMsg = '';
    verificationData.step3ErrorMsg = '';
    verificationData.step3Complete = false;
    verificationData.step3Failed = false;

    if (!isAccountAccess) {
      fraudVerificationData.customEmail = '';
      fraudVerificationData.customMobileNumber = '';
      fraudVerificationData.isEmailSelected = false;
      fraudVerificationData.isMobileSelected = false;
      fraudVerificationData.isCustomEmailSelected = false;
      fraudVerificationData.isCustomMobileSelected = false;
      fraudVerificationData.countryCode = 'US';
      fraudVerificationData.countryCallingCode = '+1';
      fraudVerificationData.defaultSelectedValue = '';
    }
    if (clearverfication) {
      const verificationId = verificationData?.verificationId;
      this.invalidateIdentityVerificationSession(verificationId);
    }
  }

  resetClearIdentityData(isAccountAccess: boolean): void {
      const activeTab = this.rootScope.activeCustTab;  
      activeTab.clearIdentityData = new clearIdentityData();
      activeTab.clearFraudIdentityData = new clearFraudIdentityData();    
      isAccountAccess?activeTab.clearIdentityData.completedAllSteps = true : activeTab.clearFraudIdentityData.completedAllSteps = true;
  }

  downgradeSLForFraudAccount(): void {

    this.rootScope.activeCustTab.genesysAttributes = {
      ...this.rootScope.activeCustTab.genesysAttributes,
      CS_AUTH_CD: '',
      CP_INDICATIVE_DATA_SECURED: false
    };
    
    this.rootScope.patchGENAttribute.next({
      conversationId: this.rootScope.activeCustTab.conversationId,
       participantId: this.rootScope.activeCustTab.customerParticipantId,
       body: { 
        attributes: {
        CS_AUTH_CD: '',
        CS_SECURITY_LEVEL: Constants.securityLevels.SL2,
        PINV: "U",
        CP_INDICATIVE_DATA_SECURED: false
      } 
    }
    });
    this.rootScope.activeCustTab.iconClass = 'red';
    this.rootScope.activeCustTab.CS_SECURITY_LEVEL = Constants.securityLevels.SL2;
    this.rootScope.activeCustTab.authenticateStatus = Constants.UNSECURED;

    let updtCustPayload = {
      customerSessionId: this.rootScope.activeCustTab.customerSessionId,
      cusTab: { customerType: this.rootScope.activeCustTab.customerType },
    };
    updtCustPayload.cusTab['genesysAttributes'] = this.rootScope.activeCustTab.genesysAttributes;
    updtCustPayload.cusTab['CS_SECURITY_LEVEL'] = this.rootScope.activeCustTab.CS_SECURITY_LEVEL;
    updtCustPayload.cusTab['iconClass'] = this.rootScope.activeCustTab.iconClass;
    updtCustPayload.cusTab['authenticateStatus'] = this.rootScope.activeCustTab.authenticateStatus;
    this.customerService.updateTabSL(updtCustPayload);
    /*
    @author Vamsikrishna
    CCR3-14867: Added downgradeSLForFraudAccount method to handle 
    downgrading the security level for a participant in a conversation, 
    including updating Genesys attributes and notifying the customer service. 
    This method also checks if simulation mode is active and updates the simulation records accordingly.
    */
    if (this.rootScope.simulationData?.isSimulationModeActive) {
      const index = this.rootScope.simulationRecords.findIndex(r => r.conversationId === this.rootScope.activeCustTab.conversationId);
      if (index !== -1) {
        this.rootScope.simulationRecords[index].conversationAttributes.CS_SECURITY_LEVEL = this.rootScope.activeCustTab.CS_SECURITY_LEVEL;
        this.rootScope.simulationRecords[index].conversationAttributes.CS_AUTH_CD = this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD;
      }
    }
    this.rootScope.triggerLog(`DowngradeSecurityLevelForPpt: Downgraded security level for participant ${this.rootScope.activeCustTab.customerParticipantId} in conversation ${this.rootScope.activeCustTab.conversationId}`, this.fileName, Constants.DEBUG);
  }
  

  /**
   * Starts (or restarts) a 1-second timer that updates the elapsed time on the provided identity data object.
   *
   * @param targetData - The identity data model to update. Can be either {@link clearIdentityData}
   * or {@link clearFraudIdentityData}. Its `exceededTimeLimit` flag is reset to `false` and its `timer`
   * field is updated every second with the elapsed milliseconds since `startTime`.
   * @author Vamsikrishna
   * CCR3-14771: Added startTimer method to manage the timer for both Clear Identity and Clear Fraud Identity flows, replacing the previous setInterval implementation in the component.
   * @remarks
   * - If a previous timer subscription exists, it is unsubscribed before creating a new one.
   * - Elapsed time is calculated as `Date.now() - this.startTime`.
   * - Requires `this.startTime` to be initialized before invocation.
   */
  startTimer(targetData: clearIdentityData | clearFraudIdentityData): void {
    this.timerSubscription?.unsubscribe();
    targetData.exceededTimeLimit = false;
    this.timerSubscription = interval(1000).subscribe(() => {
      targetData.timer = Date.now() - this.startTime;
    });
  }

  /**
   * Stops the currently running identity-verification timer for the active customer tab.
   *
   * This method:
   * - Resolves the correct target data model based on the current identity verification type
   *   (Account Access vs Fraud Identity).
   * - Unsubscribes from the existing timer subscription (if one exists) to halt timer updates.
   * - Resets the timer value to `0`.
   * - Optionally marks the flow as having exceeded the allowed time limit.
   *@author Vamsikrishna
    * CCR3-14771: Added stopTimer method to manage stopping the timer for both Clear Identity and Clear Fraud Identity flows, replacing the previous clearInterval implementation in the component.
   * @param timeOut - Optional flag indicating the timer ended due to timeout.
   * When `true`, the target data is marked with `exceededTimeLimit = true`.
   */
  stopTimer(timeOut?) {
    const activeTab = this.rootScope.activeCustTab;
    const targetData =
      activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS
        ? activeTab.clearIdentityData
        : activeTab.clearFraudIdentityData;
    this.timerSubscription?.unsubscribe();
    targetData.timer = 0;

    if(timeOut){
      targetData.exceededTimeLimit=true;
    }
  }

  /**
   * Parses a stringified error payload and returns a user-friendly retry message
   * when the error indicates the verification limit has been reached.
   *
   * The method safely handles invalid JSON and non-string inputs by returning
   * an empty string.
   *
   * @param errorMessage - A stringified error response that may contain a `message` property.
   * @returns The retry error message when the parsed `message` matches the configured limit constant; otherwise, an empty string.
   *
   * @remarks
   * - Returns an empty string if `errorMessage` is not a string.
   * - Returns an empty string if the input cannot be parsed as JSON.
   * - Returns an empty string when the parsed message does not match the expected limit value.
   */
  returnErrorMsg(errorMessage: string): string {

    if (typeof errorMessage === 'string') {
      try {
        return JSON.parse(errorMessage)?.error == Constants.CLEAR_VERIFICATION_CONSTANTS.IDVPPTLIMIT
          ? Constants.CLEAR_VERIFICATION_CONSTANTS.RETRY_ERROR_MSG
          : '';
      } catch {
        return '';
      }
    }
    return '';
  }

  simulationAIDV(targetData,isAccountAccess){
    this.setVerificationStepState(targetData, true);
    this.isSubmitBtnClicked = false;
    this.startTime = Date.now();
    this.startTimer(targetData);
    this.intervalId = setTimeout(() => {
      targetData.step3Complete = true;
      targetData.step3InfoMsg = '';
      clearTimeout(this.intervalId);
      this.stopTimer();
      this.updateSecurityForPpt();
      this.resetClearIdentityData(isAccountAccess);
    }, Constants.AIDV_SIMULATION_DURATION);
      
  }

}
